import { render, staticRenderFns } from "./OralExpressionGetVip.vue?vue&type=template&id=111b974a&scoped=true&"
import script from "./OralExpressionGetVip.vue?vue&type=script&lang=js&"
export * from "./OralExpressionGetVip.vue?vue&type=script&lang=js&"
import style0 from "./OralExpressionGetVip.vue?vue&type=style&index=0&id=111b974a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b974a",
  null
  
)

export default component.exports